import { Stack, Typography } from '@mui/material';

import { ConditionsContainer } from '@styles/ContactManager/DealStyles';

import { IConditionsProp, IDeal } from '../interfaces';
import { ConditionsForm } from './ConditionsForm';

export const Conditions = ({ deal = {} as IDeal, otherIncomes, reloadDeal, reloadDeals, isLoading, dealSavePreValidation, ...props }: IConditionsProp) => {
  return (
    <Stack>
      <Typography
        variant="h3"
        marginBottom="10px"
      >
        Conditions
      </Typography>
      <ConditionsContainer>
        <ConditionsForm
          deal={deal}
          otherIncomes={otherIncomes}
          reloadDeal={reloadDeal}
          reloadDeals={reloadDeals}
          isLoading={isLoading}
          dealSavePreValidation={dealSavePreValidation}
          {...props}
        />
      </ConditionsContainer>
    </Stack>
  );
};
